import type { IBodyUser, IBodyUserCustomer } from '@/types/user.type';
import { reactive, ref } from 'vue';

export const user_customer_page = ref(1);
export const user_customer_id = ref(null);
export const isDeletedFromUser = ref(false);
export const user_staff_page = ref(1);
export const userId = ref(null);
export const user_page = ref(1);
export const user_email_page = ref<any>(null);
export const user_phone_page = ref<any>(null);
export const user_role_page = ref<any>('store_manager');
export const user_staff_id = ref(null);
export const statusStaff = ref('all');
export const designationStaff = ref(null);
export const qStaff = ref<any>(null);
export const sortBy = ref<any>('label');
export const sortDir = ref<any>('ASC');
export const isAtcivatedWatch = ref(false);
export const isAtcivatedWatchUser = ref(false);
export const form_Client_user_Body = reactive<IBodyUserCustomer>({
  firstname: '',
  lastname: '',
});
export const form_user_Body = reactive<IBodyUser>({
  email: '',
  password: '',
  restaurantId: '62655039-0c78-41dd-9f1a-ea33ab548062',
});

export const form_user_Body_update = reactive<any>({
  email: '',
  phone: '',
  firstname: '',
  lastname: '',
  secret: '',
  roleId: '',
});

export const roleId = ref<string[]>([]);
export const isDeletedFromClient = ref(false);
